import type {LocationWeatherFragment} from 'nutshell-graphql-types';

import {MAPLIBRE_ZOOM_LEVELS, LOCATION_ACCURACY, WEATHER_ILLUSTRATION_BY_STATE} from './consts';
import type {WeatherState} from './types';

export function getTargetZoom(
    isHovered: boolean,
    isSuperZoom: boolean,
    locationAccuracy: number
): number {
    const canHoverZoom = locationAccuracy > LOCATION_ACCURACY.subregion;
    const canSuperZoom = locationAccuracy > LOCATION_ACCURACY.street;

    if (isSuperZoom && canSuperZoom) return MAPLIBRE_ZOOM_LEVELS.superZoom;
    if (isHovered && canHoverZoom) return MAPLIBRE_ZOOM_LEVELS.hover;

    return MAPLIBRE_ZOOM_LEVELS.base;
}

export function getGoogleMapsUrl(latitude: number, longitude: number): string {
    return `https://maps.google.com?q=${encodeURIComponent(`${latitude},${longitude}`)}`;
}

export function getWeatherIllustrationSrc(weather: LocationWeatherFragment): string {
    const conditionState = weather.condition as WeatherState | null | undefined;
    if (conditionState && typeof WEATHER_ILLUSTRATION_BY_STATE[conditionState] !== 'undefined') {
        return WEATHER_ILLUSTRATION_BY_STATE[conditionState];
    }

    return WEATHER_ILLUSTRATION_BY_STATE['cloudy-day'];
}
